// extracted by mini-css-extract-plugin
export var featured_articles = "FeaturedArticles-module--featured_articles--mlzAe";
export var featured_articles__wrapper = "FeaturedArticles-module--featured_articles__wrapper--PD5dg";